import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Mariana González',
  age: 38,
  location: 'La Plata, Buenos Aires',
  text: 'Con este material, las clases fluyen solas. Mis alumnos ahora opinan, discuten y hasta me piden seguir en el recreo.'
}, {
  name: 'Esteban Rodríguez',
  age: 45,
  location: 'Córdoba Capital',
  text: 'Sé exactamente qué dar cada semana. Me devolvió la tranquilidad de ir al aula sabiendo que la clase va a salir bien.'
}, {
  name: 'Laura Martínez',
  age: 34,
  location: 'Rosario, Santa Fe',
  text: 'Mis alumnos de 5to siempre decían que Política era aburrida. Desde que uso este sistema, participan un montón.'
}, {
  name: 'Patricia Sánchez',
  age: 52,
  location: 'CABA, Buenos Aires',
  text: 'Después de 25 años de docencia, esto me renovó las ganas de enseñar. Es práctico y funciona de verdad.'
}, {
  name: 'Javier López',
  age: 41,
  location: 'Mendoza Capital',
  text: 'Me ahorré fines de semana enteros de planificación. El clima del aula cambió completamente.'
}];
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const scrollToPurchase = () => document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
  const prev = () => setCurrent(c => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent(c => (c + 1) % testimonials.length);
  const visible = [testimonials[current], testimonials[(current + 1) % testimonials.length], testimonials[(current + 2) % testimonials.length]];
  return <section className="bg-[#FDF6E3] py-12 px-4 sm:px-6 lg:px-8" data-id="element-321">
      <div className="max-w-5xl mx-auto" data-id="element-322">
        {/* Header */}
        <div className="flex items-center justify-between mb-6" data-id="element-323">
          <div data-id="element-324">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1e3a5a]" data-id="element-325">
              Lo que dicen otros docentes
            </h2>
            <div className="flex items-center gap-2 mt-1" data-id="element-326">
              <div className="flex gap-0.5" data-id="element-327">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-[#d4a853] fill-[#d4a853]" data-id="element-328" />)}
              </div>
              <span className="text-sm text-gray-500" data-id="element-329">+500 docentes</span>
            </div>
          </div>
          <div className="flex gap-2" data-id="element-330">
            <button onClick={prev} className="bg-white border border-[#d4a853]/30 text-[#1e3a5a] p-2 rounded-full hover:bg-[#d4a853] hover:text-white transition-colors shadow-sm" data-id="element-331">
              <ChevronLeft className="w-4 h-4" data-id="element-332" />
            </button>
            <button onClick={next} className="bg-white border border-[#d4a853]/30 text-[#1e3a5a] p-2 rounded-full hover:bg-[#d4a853] hover:text-white transition-colors shadow-sm" data-id="element-333">
              <ChevronRight className="w-4 h-4" data-id="element-334" />
            </button>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-335">
          {visible.map((t, i) => <div key={`${current}-${i}`} onClick={scrollToPurchase} className="bg-white p-5 rounded-xl shadow-sm border border-[#d4a853]/20 cursor-pointer hover:shadow-md transition-shadow" data-id="element-336">
              <div className="flex gap-0.5 mb-3" data-id="element-337">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-[#d4a853] fill-[#d4a853]" data-id="element-338" />)}
              </div>
              <p className="text-gray-700 text-sm italic mb-4" data-id="element-339">"{t.text}"</p>
              <div className="pt-3 border-t border-gray-100" data-id="element-340">
                <p className="font-bold text-[#1e3a5a] text-sm" data-id="element-341">{t.name}</p>
                <p className="text-xs text-gray-400" data-id="element-342">
                  {t.age} años · {t.location}
                </p>
              </div>
            </div>)}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-1.5 mt-4" data-id="element-343">
          {testimonials.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`rounded-full transition-all duration-300 ${i === current ? 'w-6 h-2 bg-[#d4a853]' : 'w-2 h-2 bg-gray-300'}`} data-id="element-344" />)}
        </div>
      </div>
    </section>;
}